import { useState } from "react";
import BlueButton from "../../../../Component/Common/BlueButton";
import { BASE_URL } from "../../../../config/api";
import toast from "react-hot-toast";
import { cn } from "../Invoice/invoiceUtils";

export default function PhoneVerifyModal({ onResult }) {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [verified, setVerified] = useState(false);

  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

  const isRetailerMobile =
    typeof window !== "undefined" &&
    window.innerWidth < 640 &&
    (authUser?.role === 5 || authUser?.role === 6 );

  const handleVerify = async () => {
    if (!phone || phone.length !== 10) {
      setError("Enter valid 10 digit phone number");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await fetch(`${BASE_URL}warranty/check-customer`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile: phone }),
      });

      const data = await res.json();

      if (res.ok && data.status === true) {
        toast.success(data.message || "Customer found");
        setVerified(true);
        onResult(true, data.data.mobile, data.data);
        return;
      }

      if (res.status === 404 && data?.message === "No customer found") {
        toast.success("Phone verified. New customer");
        setVerified(true);
        onResult(true, phone, null);
        return;
      }

      toast.error(data?.message || "Verification failed");
      onResult(false, null, null);

    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
      onResult(false, null, null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={cn(
        "rounded-2xl p-4 space-y-4 transition-all duration-300",
        isRetailerMobile
          ? "glass-small-card bg-white/10 backdrop-blur-2xl border border-white/20"
          : "border bg-slate-50"
      )}
    >
      <div>
        <h3
          className={cn(
            "text-sm font-semibold",
            isRetailerMobile ? "text-black" : "text-slate-800"
          )}
        >
          Verify Customer Phone
        </h3>

        <p
          className={cn(
            "text-xs",
            isRetailerMobile ? "text-black/70" : "text-slate-500"
          )}
        >
          Enter mobile number to check existing customer
        </p>
      </div>

      <div className="flex gap-3 items-start">
        <input
          type="tel"
          value={phone}
          maxLength={10}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "");
            setPhone(value);
            onResult(false, value, null);
          }}
          placeholder="Enter 10 digit mobile"
          className={cn(
            "flex-1 px-4 py-2.5 rounded-xl text-sm outline-none transition",
            isRetailerMobile
              ? "glass-small-card bg-white/10 text-black placeholder-black/50 border border-white/30 focus:ring-2 focus:ring-white/40 !text-left w-[150px]"
              : "border bg-white"
          )}
        />

        <BlueButton
          onClick={handleVerify}
          disabled={loading || verified}
          className={cn(
            isRetailerMobile && "px-5 py-3",
            verified && "bg-green-600 hover:bg-green-600 cursor-default"
          )}
        >
          {loading ? "Verifying..." : verified ? "Verified ✓" : "Verify"}
        </BlueButton>
      </div>

      {error && (
        <p
          className={cn(
            "text-xs",
            isRetailerMobile ? "text-red-300" : "text-red-500"
          )}
        >
          {error}
        </p>
      )}
    </div>
  );
}


// import { useState } from "react";
// import BlueButton from "../../../../Component/Common/BlueButton";
// import { BASE_URL } from "../../../../config/api";
// import toast from "react-hot-toast";

// export default function PhoneVerifyModal({ onResult }) {
//   const [phone, setPhone] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const handleVerify = async () => {
//     if (!phone || phone.length !== 10) {
//       setError("Enter valid 10 digit phone number");
//       return;
//     }

//     setLoading(true);
//     setError("");

//     try {
//       const res = await fetch(`${BASE_URL}warranty/check-customer`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ mobile: phone }),
//       });

//       const data = await res.json();

//       // ✅ EXISTING CUSTOMER (200)
//       if (res.ok && data.status === true) {
//         toast.success(data.message || "Customer found");
//         onResult(true, data.data.mobile, data.data);
//         return;
//       }

//       // ✅ NEW CUSTOMER (404 → No customer found)
//       if (res.status === 404 && data?.message === "No customer found") {
//         toast.success("Phone verified. New customer");
//         onResult(true, phone, null); // 👈 allow user to enter details
//         return;
//       }

//       // ❌ Any other failure
//       toast.error(data?.message || "Verification failed");
//       onResult(false, null, null);

//     } catch (err) {
//       console.error(err);
//       toast.error("Something went wrong");
//       onResult(false, null, null);
//     } finally {
//       setLoading(false);
//     }
//   };


//   return (
//     <div className="rounded-xl border bg-slate-50 p-4 space-y-3">
//       <div>
//         <h3 className="text-sm font-semibold text-slate-800">
//           Verify Customer Phone
//         </h3>
//         <p className="text-xs text-slate-500">
//           Enter mobile number to check existing customer
//         </p>
//       </div>

//       <div className="flex gap-3 items-start">
//         <input
//           type="tel"
//           value={phone}
//           maxLength={10}
//           onChange={(e) => {
//             const value = e.target.value.replace(/\D/g, "");
//             setPhone(value);

//             // 🔥 Notify parent that phone changed
//             onResult(false, value, null);
//           }}

//           placeholder="Enter 10 digit mobile"
//           className="flex-1 px-3 py-2 border rounded-lg text-sm w-[120px]"
//         />

//         <BlueButton onClick={handleVerify} disabled={loading}>
//           {loading ? "Verifying..." : "Verify"}
//         </BlueButton>
//       </div>

//       {error && <p className="text-xs text-red-500">{error}</p>}
//     </div>
//   );
// }


// import { useState } from "react";
// import BlueButton from "../../../../Component/Common/BlueButton";
// import { BASE_URL } from "../../../../config/api";
// import toast from "react-hot-toast";

// export default function PhoneVerifyModal({ onClose, onResult }) {
//   const [phone, setPhone] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const handleVerify = async () => {
//   if (!phone || phone.length !== 10) {
//     setError("Enter valid 10 digit phone number");
//     return;
//   }

//   setLoading(true);
//   setError("");

//   try {
//     const res = await fetch(`${BASE_URL}warranty/check-customer`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ mobile: phone }),
//     });

//     const data = await res.json();

//     /**
//      * ✅ CASE 1: CUSTOMER FOUND
//      * status = true (200)
//      */
//     if (res.ok && data.status === true) {
//       toast.success(data.message || "Customer found");

//       // ✅ pass API mobile + customer
//       onResult(true, data.data.mobile, data.data);
//       return;
//     }

//     /**
//      * ✅ CASE 2: NO CUSTOMER FOUND (404)
//      * Phone is STILL verified
//      */
//     if (!res.ok && data?.message === "No customer found") {
//       toast.success("Phone verified. New customer");

//       // ✅ pass ENTERED phone
//       onResult(true, phone, null);
//       return;
//     }

//     /**
//      * ❌ REAL FAILURE
//      */
//     toast.error(data?.message || "Verification failed");
//     onResult(false, null, null);

//   } catch (err) {
//     console.error(err);
//     toast.error("Something went wrong");
//     onResult(false, null, null);
//   } finally {
//     setLoading(false);
//   }
// };


//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
//       <div className="bg-white w-full max-w-sm rounded-xl shadow-lg p-6">

//         <h3 className="text-lg font-bold mb-2">Verify Phone</h3>
//         <p className="text-sm text-slate-500 mb-4">
//           Enter phone number to verify customer
//         </p>

//         <input
//           type="tel"
//           value={phone}
//           maxLength={10}
//           onChange={(e) =>
//             setPhone(e.target.value.replace(/\D/g, ""))
//           }
//           placeholder="Enter phone number"
//           className="w-full px-3 py-2 border rounded-lg text-sm"
//         />

//         {error && <p className="text-xs text-red-500 mt-1">{error}</p>}

//         <div className="flex justify-end gap-2 mt-5">
//           <button
//             onClick={onClose}
//             className="text-sm px-4 py-2 rounded-lg border"
//             disabled={loading}
//           >
//             Cancel
//           </button>

//           <BlueButton onClick={handleVerify} disabled={loading}>
//             {loading ? "Verifying..." : "Verify"}
//           </BlueButton>
//         </div>
//       </div>
//     </div>
//   );
// }
